<template>
  <WsVersion
    :label="label"
    :localeMode="true"
    :id="$route.params.id"
    :modelName="modelName"
    :versionModelName="versionModelName"
    :fields="versionFields"
    :showFields="showFields"
    :titleKey="'last_version.name'"
    :hasCatchVersion="hasCatchVersion"
  ></WsVersion>
</template>

<script>
import model from "@/models/risk_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    versionModelName: model.versionModelName,
    versionFields: model.fields.last_version.fields,
    hasCatchVersion: true,
    showFields: ["locales", "updated_at", "updated_admin", ],
  }),
};
</script>

<style>
</style>